export const selectClientSelection = (state) =>
  state.quoteCreate.clientSelection;
